// src/composables/useTour.js
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import i18n from "@/plugins/i18n";

export function useTour() {
    const startTour = () => {
        const tour = driver({
            showProgress: true,
            showButtons: ["next", "previous", "close"],
            nextBtnText: i18n.global.t("tour.buttons.next"),
            prevBtnText: i18n.global.t("tour.buttons.prev"),
            doneBtnText: i18n.global.t("tour.buttons.done"),
            progressText: "{{current}} / {{total}}",
            steps: [
                {
                    element: "#kt_aside_menu",
                    popover: {
                        title: i18n.global.t("tour.steps.step1.title"),
                        description: i18n.global.t("tour.steps.step1.description"),
                        side: "right",
                        align: "start",
                    },
                },
                {
                    element: "#step-shop-dashboard",
                    popover: {
                        title: i18n.global.t("tour.steps.step2.title"),
                        description: i18n.global.t("tour.steps.step2.description"),
                        side: "bottom",
                        align: "start",
                    },
                },
                {
                    element: "#contacts-path",
                    popover: {
                        title: i18n.global.t("tour.steps.step3.title"),
                        description: i18n.global.t("tour.steps.step3.description"),
                        side: "right",
                        align: "start",
                    },
                },
                {
                    element: "#step-shops",
                    popover: {
                        title: i18n.global.t("tour.steps.step4.title"),
                        description: i18n.global.t("tour.steps.step4.description"),
                        side: "right",
                        align: "start",
                    },
                },
                {
                    element: "#step-shops",
                    popover: {
                        title: i18n.global.t("tour.steps.step4-0.title"),
                        description: i18n.global.t("tour.steps.step4-0.description"),
                        side: "right",
                        align: "start",
                    },
                },
                {
                    element: "#step-shops",
                    popover: {
                        title: i18n.global.t("tour.steps.step4-1.title"),
                        description: i18n.global.t("tour.steps.step4-1.description"),
                        side: "right",
                        align: "start",
                    },
                },
                {
                    element: "#step-statistics",
                    popover: {
                        title: i18n.global.t("tour.steps.step5.title"),
                        description: i18n.global.t("tour.steps.step5.description"),
                        side: "right",
                        align: "start",
                    },
                },
                {
                    element: "#step-warehouse",
                    popover: {
                        title: i18n.global.t("tour.steps.step6.title"),
                        description: i18n.global.t("tour.steps.step6.description"),
                        side: "right",
                        align: "start",
                    },
                },
                {
                    element: "#step-pos",
                    popover: {
                        title: i18n.global.t("tour.steps.step7.title"),
                        description: i18n.global.t("tour.steps.step7.description"),
                        side: "right",
                        align: "start",
                    },
                },
                {
                    element: "#step-interface-pos",
                    popover: {
                        title: i18n.global.t("tour.steps.step8.title"),
                        description: i18n.global.t("tour.steps.step8.description"),
                        side: "right",
                        align: "start",
                    },
                },
                {
                    element: "#step-state",
                    popover: {
                        title: i18n.global.t("tour.steps.step9.title"),
                        description: i18n.global.t("tour.steps.step9.description"),
                        side: "right",
                        align: "start",
                    },
                },
                {
                    element: "#step-setting",
                    popover: {
                        title: i18n.global.t("tour.steps.step10.title"),
                        description: i18n.global.t("tour.steps.step10.description"),
                        side: "right",
                        align: "end",
                    },
                },
                {
                    element: "#step-profil",
                    popover: {
                        title: i18n.global.t("tour.steps.step11.title"),
                        description: i18n.global.t("tour.steps.step11.description"),
                        side: "left",
                        align: "end",
                    },
                },
            ],
        });

        tour.drive();
    };

    return { startTour };
}